module.exports = __webpack_public_path__ + "img/cash.3865b27f.png";